import { useState, useMemo, useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Badge,
  IconButton,
  InputBase,
  Divider,
  Tooltip,
  Card,
  useTheme,
  Chip,
  Button,
  Tabs,
  Tab,
  CircularProgress,
  Modal,
  Dialog,
  DialogContent,
} from "@mui/material";
import { observer } from "mobx-react";
import { useSearchParams } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import LogoutIcon from "@mui/icons-material/Logout";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import dayjs from "dayjs";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FlagIcon from "@mui/icons-material/Flag";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import ArrowForwardTwoToneIcon from "@mui/icons-material/ArrowForwardTwoTone";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppButton from "../../../components/common/buttons/AppButton";
import {
  FilterMenuType,
  FilterSidebarMenu,
} from "../../../../models/FilterMenu";
import { ModuleType } from "../../../../models/ModuleType";
import { FilterValue } from "../../../../models/Filters/FilterValue";
import FilterSidebar from "../../../components/common/filter/FilterSidebar";
import { OrderType } from "../../../../models/Project/OrderType";
import CustomTypography from "../../../components/common/form/CustomTypography";
import OpsSyncProductTable from "../../../components/projects/Ops-sync/OpsSyncProductTable";
import AppButtonDropdown from "../../../components/common/buttons/AppButtonDropdown";
import OpsSyncInstructionPopup from "./OpsSyncInstructionPopup";
import OpsSyncTaskTrackerTable from "../../../components/projects/Ops-sync/opsSyncTaskTrackerTable";
import ArchiveOrderPopup from "./OpsSyncArchiveOrderPopup";
import AddEditTask from "../../task-tracker/AddEditTask";
import { useStores } from "../../../../use-stores";
import AppTablePagenation from "../../../components/common/pages/AppTablePagenation";
import { useNotification } from "../../../../utils/NotificationsContext";
import SuccessPopup from "../../../components/common/pop-up/SuccessPopup";
import ConfirmationPopup from "../../../components/common/pop-up/ConfirmationPopup";
import GlobeIcon from "../../../../assets/globe.png";
import flagIcon from "../../../../assets/flag.png";
import DispatchIcon from "../../../../assets/forward.png";
import POCIcon from "../../../../assets/profile.png";
import TATIcon from "../../../../assets/clockhour.png";
import CalendarIcon from "../../../../assets/calendaropssync.png";
import chatGif from "../../../../assets/comments.png";
import OrderIcon from "../../../../assets/OrderIcon.png";
import {
  ProjectFeedbackType,
  ProjectRatingRequest,
} from "../../../../models/OpsSync/OpsSyncFeedbackForm";
import type { FeedbackSubmissionPayload } from "../../../../models/OpsSync/OpsSyncFeedbackForm";
import {
  getBaseFilters,
  OpsSyncFilters,
  OpsSyncSelectedFilters,
  parseQueryParamsForOpsSyncFilters,
} from "../../../../models/OpsSync/OpsSyncFilter";
import { Task } from "../../../../models/TaskTracker/Task";
import { SortType, SortTypeList } from "../../../../models/SortType";
import { ProjectPaymentStatus } from "../../../../models/ProjectManagement/ProjectPaymentStatus";
import { ProjectManagementBasicDetails } from "../../../../models/ProjectManagement/ProjectManagementBasicDetails";
import { ProjectSortingField } from "../../../../models/ProjectManagement/ProjectSortingField";
import OpsSyncRatingExperience from "./OpsSyncRatingExperience";
import AppDropDown from "../../../components/common/filter/AppDropDown";
import { status_list } from "../../../../models/TaskTracker/TaskStatus";
import AppSearchDropDown2 from "../../../components/common/filter/AppSearchDropdown2";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { DispatchDateFilterType } from "../../../../models/Project/DispatchDateFilterType";

const OpsSync = () => {
  let apiTimer: NodeJS.Timeout | null = null;
  const { TaskTrackerStore, projectManagementStore } = useStores();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const { showError, showSuccess } = useNotification();
  const [successPopup, setSuccessPopup] = useState({
    open: false,
    message: "",
  });
  const [archiveConfirmationPopup, setArchiveConfirmationPopup] =
    useState<boolean>(false);
  const [unarchiveConfirmationPopup, setUnarchiveConfirmationPopup] =
    useState<boolean>(false);
  const [archiveChoicePopup, setArchiveChoicePopup] =
    useState<boolean>(false);
  const [feedbackOnlyMode, setFeedbackOnlyMode] = useState<boolean>(false);
  const [feedbackInlineSuccessMessage, setFeedbackInlineSuccessMessage] =
    useState<string | null>(null);
  //Tab States
  const [tabStates, setTabStates] = useState({
    orderListingTab: "active",
    ProductSectionTab: "information",
    RatingsSectionTab: "ratings",
    ActionOptionTab: 0,
  });
  const { orderListingTab, ProductSectionTab } = tabStates;

  //Popup Usestates
  const [popupStates, setPopupStates] = useState({
    instruction: false,
    Feedback: false,
  });
  const [openCreateTaskModal, setOpenCreateTaskModal] =
    useState<boolean>(false);

  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [filterCount, setFilterCount] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedFiltersData, setSelectedFiltersData] = useState<FilterValue[]>(
    [],
  );
  const [fetchedOpsSyncProjectCategories, setFetchedOpsSyncProjectCategories] =
    useState(false);

  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [allowDefaultSelection, setAllowDefaultSelection] =
    useState<boolean>(true);

  const OPS_SYNC_FILTERS_KEY = "OPS_SYNC_FILTERS_KEY";
  const initialFilters: OpsSyncFilters = parseQueryParamsForOpsSyncFilters(
    localStorage.getItem(OPS_SYNC_FILTERS_KEY)
      ? JSON.parse(localStorage.getItem(OPS_SYNC_FILTERS_KEY)!)
      : null,
    searchParams,
  );

  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const selectedOrderId = searchParams.get("order_id")
    ? parseInt(searchParams.get("order_id")!)
    : null;

  const [filters, setFilters] = useState<OpsSyncFilters>(initialFilters);
  const [selectedFilters, setSelectedFilters] =
    useState<OpsSyncSelectedFilters>({
      ...initialFilters,
      created_date_from: null,
      created_date_to: null,
      dispatch_date_from: null,
      dispatch_date_to: null,
    });

  useEffect(() => {
    const newSearchParams = new URLSearchParams();
    Object.entries(selectedFilters).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          if (value.length > 0) {
            newSearchParams.set(key, value.map((item) => item.id).join(","));
          }
        } else {
          newSearchParams.set(key, value.toString());
        }
      }
    });

    if (selectedOrderId) {
      newSearchParams.set("order_id", selectedOrderId.toString());
    }

    setSearchParams(newSearchParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters, selectedOrderId]);

  useEffect(() => {
    if (
      projectManagementStore?.projectManagementList?.length > 0 &&
      !selectedOrderId &&
      allowDefaultSelection
    ) {
      const firstOrder = projectManagementStore.projectManagementList[0];
      updateSelectedOrderInUrl(firstOrder.order_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectManagementStore?.projectManagementList, allowDefaultSelection]);

  useEffect(() => {
    if (selectedOrderId) {
      projectManagementStore.setRefreshState("basic", true);
      projectManagementStore
        .getProjectDetails(selectedOrderId)
        .then(() => {
          projectManagementStore.setRefreshState("basic", false);
        })
        .catch((error) => {
          projectManagementStore.setRefreshState("basic", false);
          showError(
            "Error occurred",
            error?.response?.data?.message || "Failed to fetch basic details.",
          );
        });
    } else {
      projectManagementStore.projectDetails = null;
      projectManagementStore.opsSyncProjectProductProgress = [];
      projectManagementStore.projectRatings = [];
      TaskTrackerStore.tasks = [];
      TaskTrackerStore.total_count = 0;
      TaskTrackerStore.total_pages = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderId]);

  useEffect(() => {
    if (selectedOrderId) {
      projectManagementStore.setRefreshState("information", true);
      projectManagementStore
        .getOpsSyncProjectProductProgress(selectedOrderId)
        .then(() => {
          projectManagementStore.setRefreshState("information", false);
        })
        .catch((error) => {
          projectManagementStore.setRefreshState("information", false);
          showError(
            "Error occurred",
            error?.response?.data?.message ||
            "Failed to fetch product progress.",
          );
        });
    } else {
      projectManagementStore.opsSyncProjectProductProgress = [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderId]);

  useEffect(() => {
    return () => {
      if (apiTimer) {
        clearTimeout(apiTimer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const totalCount = projectManagementStore.total_count;
    const limit = filters.limit || 10;
    const currentPage = filters.page_no || 1;

    if (totalCount > 0) {
      const maxPage = Math.ceil(totalCount / limit);

      if (currentPage > maxPage) {
        const correctedFilters = {
          ...filters,
          page_no: 1,
        };
        setFilters(correctedFilters);
        updateSelectedFilters(correctedFilters);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectManagementStore.total_count, filters.limit, filters.page_no]);

  const filterMenu: FilterSidebarMenu[] = useMemo(() => {
    return [
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.LOCAL_SINGLE_SELECT,
        label: "Dispatch Filter Type",
        list: DispatchDateFilterType,
        placeholder: "Select Dispatch Filter Type",
        value: filters?.dispatch_date_filter_type
          ? [filters?.dispatch_date_filter_type]
          : [],
        onChange: (selectedValues: FilterValue[]) => {
          const value =
            selectedValues.length > 0
              ? DispatchDateFilterType.filter(
                (item) => selectedValues[0].id === item.id,
              )[0]
              : null;

          if (value) {
            switch (value.value) {
              case "Dispatch Today/Missed":
                setFilters((prev) => ({
                  ...prev,
                  dispatch_date_from: null,
                  dispatch_date_to: dayjs().startOf("day"),
                  dispatch_date_filter_type: value,
                }));
                break;
              case "Dispatch In 1-3 Days":
                setFilters((prev) => ({
                  ...prev,
                  dispatch_date_from: dayjs().add(1, "day").startOf("day"),
                  dispatch_date_to: dayjs().add(3, "days").startOf("day"),
                  dispatch_date_filter_type: value,
                }));
                break;
              case "Dispatch In 4-7 Days":
                setFilters((prev) => ({
                  ...prev,
                  dispatch_date_from: dayjs().add(4, "day").startOf("day"),
                  dispatch_date_to: dayjs().add(7, "days").startOf("day"),
                  dispatch_date_filter_type: value,
                }));
                break;
              case "Dispatch In 7+ Days":
                setFilters((prev) => ({
                  ...prev,
                  dispatch_date_from: dayjs().add(8, "day").startOf("day"),
                  dispatch_date_to: null,
                  dispatch_date_filter_type: value,
                }));
                break;
              default:
                setFilters((prev) => ({
                  ...prev,
                  dispatch_date_filter_type: value,
                }));
                break;
            }
          }
        },
      },
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.DATERANGE,
        label: "Dispatch Date",
        value: {
          startDate: filters.dispatch_date_from || null,
          endDate: filters.dispatch_date_to || null,
        },
        onChange: (selectedValues) => {
          setFilters((prev) => {
            return {
              ...prev,
              dispatch_date_from: selectedValues.startDate,
              dispatch_date_to: selectedValues.endDate,
              dispatch_date_filter_type: null,
            };
          });
        },
      },
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.DATERANGE,
        label: "Created Date",
        value: {
          startDate: filters.created_date_from || null,
          endDate: filters.created_date_to || null,
        },
        onChange: (selectedValues) => {
          setFilters((prev) => {
            return {
              ...prev,
              created_date_from: selectedValues.startDate,
              created_date_to: selectedValues.endDate,
            };
          });
        },
      },
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.LOCAL_MULTI_SELECT,
        label: "Payment Type",
        list: ProjectPaymentStatus.filter((item) => item.id !== "0"),
        value: filters?.payment_status_id?.map((item) => item.id) || [],
        onChange: (selectedValues: string[]) => {
          setFilters((prev) => {
            return {
              ...prev,
              payment_status_id: ProjectPaymentStatus.filter((item) =>
                selectedValues.some((selected) => selected === item.id),
              ),
            };
          });
        },
      },
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.LOCAL_MULTI_SELECT,
        subType: "order",
        label: "Order Types",
        list: OrderType,
        value: filters?.order_type?.map((item) => item.id) || [],
        onChange: (selectedValues: string[]) => {
          setFilters((prev) => {
            return {
              ...prev,
              order_type: OrderType.filter((item) =>
                selectedValues.some((selected) => selected === item.id),
              ),
            };
          });
        },
      },
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.LOCAL_SINGLE_SELECT,
        label: "Sort By",
        list: ProjectSortingField,
        value: filters?.sort_by
          ? ProjectSortingField.filter((item) => item.id === filters?.sort_by)
          : [],
        onChange: (selectedValues: FilterValue[]) => {
          if (selectedValues.length === 0) {
            return;
          }

          const sort_by = selectedValues[0].id;
          setFilters((prev) => {
            return {
              ...prev,
              sort_by: sort_by,
            };
          });
        },
      },
      {
        moduleType: ModuleType.PROJECT_MANAGEMENT,
        fieldType: FilterMenuType.LOCAL_SINGLE_SELECT,
        label: "Sort Type",
        list: SortTypeList,
        value: filters?.sort_type
          ? SortTypeList.filter((item) => item.value === filters?.sort_type)
          : [],
        onChange: (selectedValues: FilterValue[]) => {
          if (selectedValues.length === 0) {
            return;
          }

          const sort_type = selectedValues[0].value as SortType;
          setFilters((prev) => {
            return {
              ...prev,
              sort_type: sort_type,
            };
          });
        },
      },
    ];
  }, [filters]);

  const updateSelectedFilters = (appliedFilters: OpsSyncFilters) => {
    const filtersToStore = { ...appliedFilters };
    if (!filtersToStore.order_type?.length) {
      delete filtersToStore.order_type;
    }
    localStorage.setItem(OPS_SYNC_FILTERS_KEY, JSON.stringify(filtersToStore));

    let temp_filters_count = 0;

    if (appliedFilters?.created_date_from || appliedFilters?.created_date_to) {
      temp_filters_count++;
    }

    if (
      appliedFilters?.dispatch_date_from ||
      appliedFilters?.dispatch_date_to
    ) {
      temp_filters_count++;
    }

    setSelectedFilters((_) => ({
      ...appliedFilters,
      created_date_from:
        appliedFilters?.created_date_from &&
          typeof appliedFilters.created_date_from.format === "function"
          ? appliedFilters.created_date_from.format("YYYY-MM-DD")
          : null,
      created_date_to:
        appliedFilters?.created_date_to &&
          typeof appliedFilters.created_date_to?.format === "function"
          ? appliedFilters.created_date_to.format("YYYY-MM-DD")
          : null,
      dispatch_date_from:
        appliedFilters?.dispatch_date_from &&
          typeof appliedFilters.dispatch_date_from.format === "function"
          ? appliedFilters.dispatch_date_from.format("YYYY-MM-DD")
          : null,
      dispatch_date_to:
        appliedFilters?.dispatch_date_to &&
          typeof appliedFilters.dispatch_date_to?.format === "function"
          ? appliedFilters.dispatch_date_to.format("YYYY-MM-DD")
          : null,
    }));

    const newFilters: React.SetStateAction<FilterValue[]> = [];

    if (appliedFilters?.order_id && appliedFilters.order_id.length > 0) {
      temp_filters_count++;
      appliedFilters.order_id.forEach((order_id) =>
        newFilters.push({ id: "order_id", value: order_id.value }),
      );
    }

    if (appliedFilters?.order_type && appliedFilters.order_type.length > 0) {
      temp_filters_count++;
      appliedFilters.order_type.forEach((order_type) =>
        newFilters.push({ id: "order_type", value: order_type.value }),
      );
    }
    if (
      appliedFilters?.payment_status_id &&
      appliedFilters.payment_status_id.length > 0
    ) {
      temp_filters_count++;
      appliedFilters.payment_status_id.forEach((payment_status_id) =>
        newFilters.push({
          id: "payment_status_id",
          value: payment_status_id.value,
        }),
      );
    }

    if (
      appliedFilters?.dispatch_date_filter_type &&
      appliedFilters.dispatch_date_filter_type.id !== "0"
    ) {
      temp_filters_count++;
      newFilters.push({
        id: "dispatch_date_filter_type",
        value: appliedFilters.dispatch_date_filter_type.value,
      });
    }

    setSelectedFiltersData(newFilters);
    setFilterCount(temp_filters_count);
  };

  useEffect(() => {
    fetchOpsSyncProjectCategories();
    fetchOpsSyncProjectTaskTypes();
    fetchDepartmentList();
    setAllowDefaultSelection(true);
    // fetchProjectList();
    updateSelectedFilters(initialFilters);
    fetchProjectList("", initialFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateSelectedOrderInUrl = (orderId: number) => {
    const currentParams = new URLSearchParams(searchParams);
    currentParams.set("order_id", orderId.toString());
    setSearchParams(currentParams);
  };
  const [taskTrackerParams, setTaskTrackerParams] = useState({
    page_no: 1,
    limit: 30,
    sortBy: "dispatch_date" as string,
    sortType: SortType.DESC,
    status: null as number | null,
    owner_id: [] as number[],
    assignee_id: [] as number[],
    selectedOwnerName: [] as string[],
    selectedAssigneeName: [] as string[],
    search_text: "" as string,
  });

  const [taskSearchTerm, setTaskSearchTerm] = useState<string>("");

  const previousTabRef = useRef<string>("information");
  const previousTaskTrackerParamsRef = useRef({
    page_no: 1,
    limit: 30,
    sortBy: "dispatch_date" as string,
    sortType: SortType.DESC,
    status: null as number | null,
    owner_id: [] as number[],
    assignee_id: [] as number[],
    selectedOwnerName: [] as string[],
    selectedAssigneeName: [] as string[],
    search_text: "" as string,
  });

  useEffect(() => {
    if (selectedOrderId && tabStates.ProductSectionTab === "task-tracker") {
      if (previousTabRef.current !== "task-tracker") {
        setTaskTrackerParams({
          page_no: 1,
          limit: 30,
          sortBy: "dispatch_date",
          sortType: SortType.DESC,
          status: null,
          owner_id: [],
          assignee_id: [],
          selectedOwnerName: [],
          selectedAssigneeName: [],
          search_text: "",
        });
        previousTabRef.current = tabStates.ProductSectionTab;
        return;
      }

      const paramsChanged =
        previousTaskTrackerParamsRef.current.sortBy !==
        taskTrackerParams.sortBy ||
        previousTaskTrackerParamsRef.current.sortType !==
        taskTrackerParams.sortType ||
        previousTaskTrackerParamsRef.current.page_no !==
        taskTrackerParams.page_no ||
        previousTaskTrackerParamsRef.current.limit !==
        taskTrackerParams.limit ||
        previousTaskTrackerParamsRef.current.status !==
        taskTrackerParams.status ||
        previousTaskTrackerParamsRef.current.owner_id !==
        taskTrackerParams.owner_id ||
        previousTaskTrackerParamsRef.current.assignee_id !==
        taskTrackerParams.assignee_id ||
        previousTaskTrackerParamsRef.current.search_text !==
        taskTrackerParams.search_text;

      if (
        TaskTrackerStore.tasks &&
        TaskTrackerStore.tasks.length > 0 &&
        TaskTrackerStore.tasks[0].order_id === selectedOrderId &&
        !paramsChanged
      ) {
        return;
      }

      previousTaskTrackerParamsRef.current = taskTrackerParams;

      TaskTrackerStore.setRefreshState("taskTracker", true);
      TaskTrackerStore?.getTasks({
        order_id: [selectedOrderId],
        page_no: taskTrackerParams.page_no,
        limit: taskTrackerParams.limit,
        sortBy: undefined,
        sortType: undefined,
        status: taskTrackerParams.status
          ? [taskTrackerParams.status]
          : undefined,
        owner_id:
          taskTrackerParams.owner_id.length > 0
            ? taskTrackerParams.owner_id
            : undefined,
        assignee_id:
          taskTrackerParams.assignee_id.length > 0
            ? taskTrackerParams.assignee_id
            : undefined,
        search_text: taskTrackerParams.search_text || undefined,
      })
        .then(() => {
          TaskTrackerStore.setRefreshState("taskTracker", false);
        })
        .catch((error) => {
          TaskTrackerStore.setRefreshState("taskTracker", false);
          showError(
            "Error occurred",
            error?.response?.data?.message || "Failed to fetch tasks.",
          );
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskTrackerParams, selectedOrderId, tabStates.ProductSectionTab]);

  useEffect(() => {
    if (selectedOrderId && tabStates.ProductSectionTab === "ratings") {
      if (previousTabRef.current !== "ratings") {
        if (
          projectManagementStore.projectRatings.length > 0 &&
          projectManagementStore.projectRatings[0]?.project_id ===
          selectedOrderId
        ) {
          return;
        }

        projectManagementStore.setRefreshState("ratings", true);
        projectManagementStore
          .getProjectRatings(selectedOrderId)
          .then(() => {
            projectManagementStore.setRefreshState("ratings", false);
          })
          .catch((error) => {
            projectManagementStore.setRefreshState("ratings", false);
            showError(
              "Error occurred",
              error?.response?.data?.message || "Failed to fetch ratings.",
            );
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderId, tabStates.ProductSectionTab]);

  useEffect(() => {
    if (previousTabRef.current !== tabStates.ProductSectionTab) {
      previousTabRef.current = tabStates.ProductSectionTab;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabStates.ProductSectionTab]);

  const fetchOpsSyncProjectCategories = () => {
    setIsLoading(true);
    projectManagementStore
      .getOpsSyncProjectCategories()
      .then(() => {
        setFetchedOpsSyncProjectCategories(true);
      })
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message ||
          "Failed to fetch project categories.",
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchOpsSyncProjectTaskTypes = () => {
    setIsLoading(true);
    projectManagementStore
      .getOpsSyncProjectTaskTypes()
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message ||
          "Failed to fetch project task types.",
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchDepartmentList = () => {
    projectManagementStore
      .getDepartmentList()
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message || "Failed to fetch department list.",
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleClickOpen = () => {
    setPopupStates((prev) => ({ ...prev, instruction: true }));
  };

  const handleRefresh = (
    type: "basic" | "information" | "taskTracker" | "ratings",
  ) => {
    if (!selectedOrderId) return;

    switch (type) {
      case "basic":
        projectManagementStore?.refreshBasicDetails(selectedOrderId);
        break;
      case "information":
        projectManagementStore?.refreshProductDetails(selectedOrderId);
        break;
      case "taskTracker":
        TaskTrackerStore?.refreshTaskTracker(
          selectedOrderId,
          taskTrackerParams,
          TaskTrackerStore,
        );
        break;
      case "ratings":
        projectManagementStore?.refreshRatings(selectedOrderId);
        break;
      default:
        break;
    }
    setTimeout(() => setIsLoading(false), 1000);
  };

  const getPriorityBandColor = (days_to_dispatch: number | null) => {
    if (tabStates.orderListingTab === "archived") {
      return theme?.palette?.purple?.main;
    }

    if (days_to_dispatch === null) {
      return theme?.palette?.customColors?.lightGreyColor;
    }

    if (days_to_dispatch <= 0) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 1,
      )?.color;
    } else if (days_to_dispatch >= 1 && days_to_dispatch <= 3) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 2,
      )?.color;
    } else if (days_to_dispatch >= 4 && days_to_dispatch <= 7) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 3,
      )?.color;
    } else if (days_to_dispatch > 7) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 4,
      )?.color;
    }
  };

  const getPriorityCategory = (days_to_dispatch: number | null) => {
    if (tabStates.orderListingTab === "archived") {
      return {
        id: -1,
        name: "Archive Order",
        color: theme?.palette?.purple?.main,
      };
    }

    if (days_to_dispatch === null) {
      return {
        id: 0,
        name: "No Category",
        color: theme?.palette?.customColors?.lightGreyColor,
      };
    }

    if (days_to_dispatch <= 0) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 1,
      );
    } else if (days_to_dispatch >= 1 && days_to_dispatch <= 3) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 2,
      );
    } else if (days_to_dispatch >= 4 && days_to_dispatch <= 7) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 3,
      );
    } else if (days_to_dispatch > 7) {
      return projectManagementStore.opsSyncProjectCategories.find(
        (cat) => cat.id === 4,
      );
    }

    return null;
  };

  const handleFilterToggle = useCallback(() => {
    setOpenFilter((prev) => !prev);
  }, []);
  const handleApplyFilters = () => {
    if (!fetchedOpsSyncProjectCategories) return;

    setIsLoading(true);
    const filtersWithResetPage = {
      ...filters,
      page_no: 1,
    };
    setFilters(filtersWithResetPage);
    updateSelectedFilters(filtersWithResetPage);
    setOpenFilter(false);

    fetchProjectList("", filtersWithResetPage);
  };

  const handleClearFilters = () => {
    setSearch("");
    setSearchTerm("");
    setIsLoading(true);
    const clearedFilters: OpsSyncFilters = {
      ...getBaseFilters(),
      order_type: [],
      search_text: "",
    };
    setFilters(clearedFilters);
    updateSelectedFilters(clearedFilters);
    fetchProjectList("", clearedFilters);
  };

  useEffect(() => {
    setTabStates((prev) => ({ ...prev, ProductSectionTab: "information" }));
    setTaskTrackerParams((prev) => ({
      ...prev,
      selectedOwnerName: [],
      selectedAssigneeName: [],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderId]);

  const fetchProjectList = (
    overrideSearchText?: string,
    overrideFilters?: OpsSyncFilters,
  ) => {
    setOpenFilter(false);
    setIsLoading(true);

    const isArchived = tabStates.orderListingTab === "archived";
    const isActive = tabStates.orderListingTab === "active";

    const activeFilters = overrideFilters || filters;

    const payload = {
      page_no: activeFilters?.page_no || 1,
      limit: activeFilters?.limit || 30,
      sort_by: activeFilters?.sort_by || "dispatch_date",
      sort_type: activeFilters?.sort_type || SortType.DESC,
      search_text:
        overrideSearchText !== undefined
          ? overrideSearchText
          : activeFilters?.search_text || "",
      order_id: activeFilters?.order_id?.map((id) => Number(id.id)),
      project_type: activeFilters?.order_type,
      payment_status_id: activeFilters?.payment_status_id,
      dispatch_date_filter_type: activeFilters?.dispatch_date_filter_type,
      archived: isArchived,
      active: isActive,
      created_date_from: activeFilters?.created_date_from ?? undefined,
      created_date_to: activeFilters?.created_date_to ?? undefined,
      dispatch_date_from: activeFilters?.dispatch_date_from ?? undefined,
      dispatch_date_to: activeFilters?.dispatch_date_to ?? undefined,
    };

    projectManagementStore
      .getOpsSyncProjectList(payload)
      .then(() => {
        // If the result is empty, remove only order_id from URL while preserving other filters
        if (
          projectManagementStore?.projectManagementList?.length === 0 &&
          selectedOrderId
        ) {
          // Create new URLSearchParams from current search params to preserve all existing parameters
          const currentParams = new URLSearchParams(window.location.search);
          currentParams.delete("order_id");
          setSearchParams(currentParams, { replace: true });
        }
      })
      .catch((error) => {
        showError("Error occurred", "Failed to fetch order listing.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value || "";
    setSearch(text);
    setSearchTerm(text);

    if (text.length === 0 && searchTerm && searchTerm.length > 0) {
      const updatedFilters = {
        ...filters,
        search_text: "",
        page_no: 1,
      };
      setFilters(updatedFilters);
      updateSelectedFilters(updatedFilters);
      fetchProjectList("", updatedFilters);
    }
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const text = searchTerm || "";

      if (text.trim().length > 0) {
        const updatedFilters = {
          ...filters,
          search_text: text,
          page_no: 1,
        };
        setFilters(updatedFilters);
        updateSelectedFilters(updatedFilters);

        fetchProjectList(text, updatedFilters);
      } else {
        const updatedFilters = {
          ...filters,
          search_text: "",
          page_no: 1,
        };
        setFilters(updatedFilters);
        updateSelectedFilters(updatedFilters);
        fetchProjectList("", updatedFilters);
      }
    }
  };

  const handleRemoveFilter = (index: number) => {
    const filterToRemove = selectedFiltersData[index];
    if (!filterToRemove || filterToRemove === null) return null;

    setIsLoading(true);
    const updatedFilters = selectedFiltersData.filter((_, i) => i !== index);
    setSelectedFiltersData(updatedFilters);

    switch (filterToRemove.id) {
      case "dispatch_date_filter_type":
        const list1 = filters.dispatch_date_filter_type;
        if (list1 && list1.id !== filterToRemove.id) {
          const updatedFilters = {
            ...filters,
            dispatch_date_filter_type: null,
            page_no: 1,
          };
          setFilters(updatedFilters);
          updateSelectedFilters(updatedFilters);
          fetchProjectList("", updatedFilters);
        }
        break;
      case "payment_status_id":
        const list = filters.payment_status_id;
        if (list && list.length > 0) {
          const updatedFilters = {
            ...filters,
            payment_status_id: list.filter(
              (item) => item.value !== filterToRemove.value,
            ),
            page_no: 1,
          };
          setFilters(updatedFilters);
          updateSelectedFilters(updatedFilters);
          fetchProjectList("", updatedFilters);
        }
        break;
      case "order_type":
        const list2 = filters.order_type;
        if (list2 && list2.length > 0) {
          const updatedFilters = {
            ...filters,
            order_type: list2.filter(
              (item) => item.value !== filterToRemove.value,
            ),
            page_no: 1,
          };
          setFilters(updatedFilters);
          updateSelectedFilters(updatedFilters);
          fetchProjectList("", updatedFilters);
        }
        break;
      case "order_id":
        const list3 = filters.order_id;
        if (list3 && list3.length > 0) {
          const updatedFilters = {
            ...filters,
            order_id: list3.filter(
              (item) => item.value !== filterToRemove.value,
            ),
            page_no: 1,
          };
          setFilters(updatedFilters);
          updateSelectedFilters(updatedFilters);
          fetchProjectList("", updatedFilters);
        }
        break;
      default:
        break;
    }
  };

  //Archive section
  const getDepartmentId = (departmentName: string): number => {
    const department = projectManagementStore.departmentList.find(
      (dept) => dept.name === departmentName,
    );
    return department ? department.id : 1;
  };

  const handleArchiveWithFeedback = (payload: FeedbackSubmissionPayload) => {
    if (!selectedOrderId) {
      showError("Error", "No order ID selected");
      return;
    }

    const ratingPayload: ProjectRatingRequest = {
      project_id: selectedOrderId,
      type: payload.type,
      overall_rating: payload.overallRating,
      cost_incurred: payload.lossIncurred ? parseFloat(payload.lossIncurred) || 0 : 0,
      ratings: payload.departmentRatings.map((dr) => ({
        department_id: getDepartmentId(dr.department),
        rating: dr.rating,
      })),
      feedback: payload.comment || "",
      files: (payload.files as unknown as string[]) || [],
    };

    projectManagementStore
      .saveProjectRating(selectedOrderId, ratingPayload)
      .then(() => {
        if (payload.archiveAfter) {
          handleArchiveOrder();
        } else {
          setFeedbackInlineSuccessMessage(
            `${payload.type === ProjectFeedbackType.TEAM ? "Team" : "Client"} feedback saved successfully!`,
          );
        }
      })
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message ||
          "Something went wrong! Please try again later.",
        );
      });
  };

  const fetchProjectRatingsForArchive = () => {
    if (!selectedOrderId) return;

    projectManagementStore.setRefreshState("ratings", true);
    projectManagementStore
      .getProjectRatings(selectedOrderId)
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message || "Failed to fetch project ratings.",
        );
      })
      .finally(() => {
        projectManagementStore.setRefreshState("ratings", false);
      });
  };

  const hasBothFeedbackFilled = () => {
    const ratings = projectManagementStore?.projectRatings || [];
    const forProject = ratings.filter((r) => r.project_id === selectedOrderId);
    const hasTeam = forProject.some((r) => r.type === 1);
    const hasClient = forProject.some((r) => r.type === 2);
    return hasTeam && hasClient;
  };

  const handleArchiveOrderClick = () => {
    if (!selectedOrderId) return;

    projectManagementStore
      .getProjectRatings(selectedOrderId)
      .then(() => {
        if (hasBothFeedbackFilled()) {
          setArchiveChoicePopup(false);
          setArchiveConfirmationPopup(true);
        } else {
          setArchiveChoicePopup(true);
        }
      })
      .catch(() => {
        setArchiveChoicePopup(true);
      });
  };

  const handleOpenArchivePopup = () => {
    setPopupStates((prev) => ({ ...prev, Feedback: true }));
    fetchProjectRatingsForArchive();
  };

  const handleCloseArchivePopup = () => {
    setPopupStates((prev) => ({ ...prev, Feedback: false }));
    setFeedbackOnlyMode(false);
    setFeedbackInlineSuccessMessage(null);
  };

  const handleArchiveOrder = () => {
    if (!selectedOrderId) {
      showError("Error", "No order selected for Archive Order");
      return;
    }

    projectManagementStore
      .makeArchived(selectedOrderId)
      .then(() => {
        setSuccessPopup({ open: true, message: "Archive Order successfully!" });
        setArchiveConfirmationPopup(false);

        const updatedOrderList =
          projectManagementStore.projectManagementList.filter(
            (order) => order.order_id !== selectedOrderId,
          );
        projectManagementStore.projectManagementList = updatedOrderList;

        projectManagementStore.total_count = Math.max(
          0,
          projectManagementStore.total_count - 1,
        );

        if (updatedOrderList.length > 0) {
          const nextOrder = updatedOrderList[0];
          updateSelectedOrderInUrl(nextOrder.order_id);
        } else {
          const currentParams = new URLSearchParams(window.location.search);
          currentParams.delete("order_id");
          setSearchParams(currentParams, { replace: true });
        }
      })
      .catch((error) => {
        showError(
          "Failed to archive order",
          error?.response?.data?.message || "Please try again.",
        );
        setArchiveConfirmationPopup(false);
      });
  };

  const handleUnarchiveOrder = () => {
    if (!selectedOrderId) {
      showError("Error", "No order selected for Unarchive Order");
      return;
    }

    projectManagementStore
      .makeUnarchived(selectedOrderId)
      .then(() => {
        showSuccess("Unarchive Order successfully!");
        setUnarchiveConfirmationPopup(false);
        const updatedOrderList =
          projectManagementStore.projectManagementList.filter(
            (order) => order.order_id !== selectedOrderId,
          );
        projectManagementStore.projectManagementList = updatedOrderList;

        projectManagementStore.total_count = Math.max(
          0,
          projectManagementStore.total_count - 1,
        );

        if (updatedOrderList.length > 0) {
          const nextOrder = updatedOrderList[0];
          updateSelectedOrderInUrl(nextOrder.order_id);
        } else {
          const currentParams = new URLSearchParams(window.location.search);
          currentParams.delete("order_id");
          setSearchParams(currentParams, { replace: true });
        }
      })
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message ||
          "Failed to send Unarchive Order. Please try again.",
        );
      })
      .finally(() => {
        setUnarchiveConfirmationPopup(false);
      });
  };

  const handleTaskStatusUpdate = (taskId: number, newStatus: number) => {
    const currentTask = TaskTrackerStore.tasks.find(
      (task: Task) => task.id === taskId,
    );

    if (!currentTask) {
      showError("Error", "Task not found");
      return;
    }

    // Transform the task data to match the expected API structure
    const updatedTask: Task = {
      // ...currentTask,
      status: newStatus,
      id: currentTask.id,
      order_id: currentTask.order_id,
      title: currentTask.title,
      due_date: currentTask.due_date,
      priority: currentTask.priority,
      description: currentTask.description,
      order_details: currentTask.order_details,
      archived: currentTask.archived,
      active: currentTask.active,
      created_date: currentTask.created_date,
      modified_date: currentTask.modified_date,
      owner_id: currentTask.owner_id,
      owner_name: currentTask.owner_name,
      reporter_id: currentTask.reporter_id,
      reporter_name: currentTask.reporter_name,
      assignees: currentTask.assignees || currentTask.assignee,
      products: currentTask.products,
    };

    TaskTrackerStore.updateTaskDetails(updatedTask)
      .then(() => {
        setSuccessPopup({
          open: true,
          message: "Task status updated successfully!",
        });

        if (selectedOrderId) {
          TaskTrackerStore?.refreshTaskTracker(
            selectedOrderId,
            taskTrackerParams,
            TaskTrackerStore,
          );
        }
      })
      .catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message ||
          "Something went wrong! Please try again later.",
        );
      });
  };

  const handleTaskStatusFilterChange = (status: string) => {
    setTaskTrackerParams((prev) => ({
      ...prev,
      status: status && status !== "0" ? Number(status) : null,
      page_no: 1, // Reset to first page when filter changes
    }));
  };

  const handleOwnerSearch = (name?: string) => {
    if (name && name.length > 2) {
      TaskTrackerStore.getAdminBySearch(name).catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message || "Failed to fetch reporters.",
        );
      });
    }
  };

  const handleAssigneeSearch = (name?: string) => {
    if (name && name.length > 2) {
      TaskTrackerStore.getAdminBySearch(name).catch((error) => {
        showError(
          "Error occurred",
          error?.response?.data?.message || "Failed to fetch assignees.",
        );
      });
    }
  };

  const handleTaskSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value || "";
    setTaskSearchTerm(text);
    setTaskTrackerParams((prev) => ({
      ...prev,
    }));

    // If the input is cleared (empty), trigger search immediately
    if (text === "") {
      setTaskTrackerParams((prev) => ({
        ...prev,
        search_text: "",
        page_no: 1, // Reset to first page when search is cleared
      }));
    }
  };

  const handleTaskSearchKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (e.key === "Enter") {
      setTaskTrackerParams((prev) => ({
        ...prev,
        search_text: taskSearchTerm,
        page_no: 1, // Reset to first page when search changes
      }));
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        minHeight: 0,
        scrollbarWidth: "none",
        position: "relative",
        width: "100%",
        background: theme?.palette?.customColors?.lightGreyColor,
      }}
    >
      {useMediaQuery("(max-width:600px)") && !sidebarOpen && (
        <IconButton
          onClick={() => setSidebarOpen(true)}
          sx={{
            position: "fixed",
            top: 92,
            left: 12,
            zIndex: 1201,
            background: theme?.palette?.customColors?.white,
            border: `1.5px solid ${theme?.palette?.customColors?.darkBlueGrey}`,
            borderRadius: "50%",
            boxShadow: 2,
            width: 30,
            height: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ArrowForwardTwoToneIcon sx={{ width: 20, height: 20 }} />
        </IconButton>
      )}
      <Box
        sx={{
          width: useMediaQuery("(max-width:600px)") ? 220 : "20%",
          minWidth: useMediaQuery("(max-width:600px)") ? 0 : "220px",
          maxWidth: useMediaQuery("(max-width:600px)") ? 220 : "320px",
          background: theme?.palette?.customColors?.darkBlueGrey,
          color: theme?.palette?.customColors?.white,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
          position: useMediaQuery("(max-width:600px)") ? "fixed" : "relative",
          left: useMediaQuery("(max-width:600px)")
            ? sidebarOpen
              ? 0
              : -240
            : 0,
          zIndex: 1200,
          transition: useMediaQuery("(max-width:600px)")
            ? "left 0.3s cubic-bezier(0.4,0,0.2,1)"
            : undefined,
          boxShadow:
            useMediaQuery("(max-width:600px)") && sidebarOpen ? 4 : undefined,
        }}
      >
        {useMediaQuery("(max-width:600px)") && sidebarOpen && (
          <IconButton
            onClick={() => setSidebarOpen(false)}
            sx={{
              position: "absolute",
              background: theme?.palette?.customColors?.white,
              border: `1.5px solid ${theme?.palette?.customColors?.darkBlueGrey}`,
              top: 20,
              right: -13,
              zIndex: 1202,
              borderRadius: "50%",
              width: 30,
              height: 30,
              "&:hover": {
                background: theme?.palette?.customColors?.white,
                boxShadow: "none",
                cursor: "default",
              },
            }}
          >
            <ArrowBackTwoToneIcon />
          </IconButton>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2.3,
          }}
        >
          <CustomTypography
            variant="heading4"
            style={{
              display: "flex",
              alignItems: "center",
              color: theme?.palette?.customColors?.white,
            }}
          >
            <Box sx={{ marginRight: 1 }}>
              <img
                src={OrderIcon}
                alt="Raw Inward Icon"
                style={{ width: 20, height: 22 }}
              />
            </Box>
            Orders
          </CustomTypography>
          <Tooltip
            placement="bottom-start"
            enterTouchDelay={0}
            arrow
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: "offset",
                    options: {
                      offset: [0, 8],
                    },
                  },
                ],
              },
              tooltip: {
                sx: {
                  backgroundColor: theme?.palette?.customColors?.white,
                  color: theme?.palette?.customColors?.blackBorder,
                  boxShadow: 1,
                  borderRadius: 1,
                  p: 2.5,
                  fontSize: "0.85rem",
                  maxWidth: 280,
                },
              },
              arrow: {
                sx: {
                  color: theme?.palette?.customColors?.white,
                },
              },
            }}
            title={
              <Box>
                <CustomTypography
                  variant="heading7"
                  style={{ paddingBottom: 10 }}
                >
                  Order Categories
                </CustomTypography>
                <Divider
                  sx={{
                    borderColor: theme?.palette?.customColors?.greyTextColor,
                    mb: 1,
                  }}
                />
                {[
                  ...(projectManagementStore.opsSyncProjectCategories || []),
                  {
                    id: -1,
                    name: "Archive Order",
                    color: theme?.palette?.purple?.main,
                  },
                ]?.map((item, idx: number) => (
                  <Box
                    key={idx + "-" + item!.name}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    mb={0.5}
                  >
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: item?.color,
                        flexShrink: 0,
                      }}
                    />
                    <CustomTypography
                      variant="body2"
                      sx={{
                        fontSize: "0.85rem",
                        color: theme?.palette?.customColors?.blackBorder,
                      }}
                    >
                      {item?.name}
                    </CustomTypography>
                  </Box>
                ))}
              </Box>
            }
          >
            <IconButton
              size="small"
              sx={{ color: theme?.palette?.customColors?.white }}
            >
              <InfoOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            px: 2,
            pb: 1.5,
            pt: 0.8,
          }}
        >
          {["active", "archived"].map((tab) => (
            <Box
              key={tab}
              sx={{
                position: "relative",
                cursor: "pointer",
                width: "50%",
                textAlign: "center",
              }}
              onClick={() => {
                const newTabState = tab;
                setTabStates((prev) => ({
                  ...prev,
                  orderListingTab: newTabState,
                }));

                setAllowDefaultSelection(true);

                const updatedFilters = {
                  ...filters,
                  archived: newTabState === "archived",
                  page_no: 1,
                };
                setFilters(updatedFilters);
                updateSelectedFilters(updatedFilters);

                setOpenFilter(false);
                setIsLoading(true);

                const isArchived = newTabState === "archived";
                const isActive = newTabState === "active";

                const payload = {
                  page_no: updatedFilters?.page_no || 1,
                  limit: updatedFilters?.limit,
                  sort_by: updatedFilters?.sort_by || "dispatch_date",
                  sort_type: updatedFilters?.sort_type || SortType.DESC,
                  search_text: updatedFilters?.search_text || "",
                  order_id: updatedFilters?.order_id?.map((id) =>
                    Number(id.id),
                  ),
                  project_type: updatedFilters?.order_type,
                  payment_status_id: updatedFilters?.payment_status_id,
                  dispatch_date_filter_type:
                    updatedFilters?.dispatch_date_filter_type,
                  archived: isArchived,
                  active: isActive,
                  created_date_from:
                    updatedFilters?.created_date_from ?? undefined,
                  created_date_to: updatedFilters?.created_date_to ?? undefined,
                  dispatch_date_from:
                    updatedFilters?.dispatch_date_from ?? undefined,
                  dispatch_date_to:
                    updatedFilters?.dispatch_date_to ?? undefined,
                };

                projectManagementStore
                  .getOpsSyncProjectList(payload)
                  .then(() => {
                    // If the result is empty, remove only order_id from URL while preserving other filters
                    if (
                      projectManagementStore?.projectManagementList?.length ===
                      0 &&
                      selectedOrderId
                    ) {
                      // Create new URLSearchParams from current search params to preserve all existing parameters
                      const currentParams = new URLSearchParams(
                        window.location.search,
                      );
                      currentParams.delete("order_id");
                      setSearchParams(currentParams, { replace: true });
                    }
                  })
                  .catch((error) => {
                    showError(
                      "Error occurred",
                      "Failed to fetch order listing.",
                    );
                  })
                  .finally(() => {
                    setIsLoading(false);
                  });
              }}
            >
              <CustomTypography
                variant="heading6"
                fontWeight={700}
                style={{
                  color:
                    orderListingTab === tab
                      ? theme?.palette?.mintGreen?.main
                      : theme?.palette?.customColors?.greyTextColor,
                  marginBottom: 4,
                }}
              >
                {tab?.charAt(0)?.toUpperCase() + tab?.slice(1)}
              </CustomTypography>

              {orderListingTab === tab && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: -6,
                    left: "10%",
                    width: "80%",
                    height: "3px",
                    backgroundColor: theme?.palette?.mintGreen?.main,
                    borderRadius: 1,
                  }}
                />
              )}
            </Box>
          ))}
        </Box>

        <Box sx={{ flex: 1, overflowY: "auto", py: 1 }}>
          {(projectManagementStore?.refreshStates.basic || isLoading) &&
            !projectManagementStore?.projectManagementList?.length ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <CircularProgress
                size={30}
                sx={{ color: theme?.palette?.customColors?.white }}
              />
              {/* <CustomTypography
                variant="body2"
                sx={{ color: theme?.palette?.customColors?.white }}
              >
                {isLoading ? "Loading orders..." : "Loading orders..."}
              </CustomTypography> */}
            </Box>
          ) : projectManagementStore?.projectManagementList?.length > 0 &&
            !isLoading ? (
            projectManagementStore?.projectManagementList?.map(
              (order: ProjectManagementBasicDetails) => {
                const isSelected = selectedOrderId === order.order_id;
                return (
                  <>
                    <Box
                      key={order.order_id}
                      onClick={() => {
                        if (selectedOrderId !== order.order_id) {
                          setAllowDefaultSelection(true);
                          updateSelectedOrderInUrl(order.order_id);
                        }
                      }}
                      sx={{
                        alignItems: "flex-start",
                        minHeight: 50,
                        marginLeft: 2,
                        marginRight: 2,
                        px: 2,
                        py: 1,
                        cursor: "pointer",
                        display: "flex",
                        borderRadius: 3,
                        backgroundColor: isSelected
                          ? `${theme?.palette?.customColors?.white}1A`
                          : "transparent",
                      }}
                    >
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: getPriorityBandColor(
                            order.days_to_dispatch || 0,
                          ),
                          mr: 1.2,
                          mt: 0.4,
                          flexShrink: 0,
                        }}
                      />
                      <Box>
                        <CustomTypography
                          variant="heading7"
                          fontWeight={700}
                          style={{
                            color: theme?.palette?.customColors?.white,
                          }}
                        >
                          #{order?.order_id} {order?.customer_name || ""}
                        </CustomTypography>
                      </Box>
                    </Box>
                  </>
                );
              },
            )
          ) : isLoading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <CircularProgress
                size={30}
                sx={{ color: theme?.palette?.customColors?.white }}
              />
              {/* <CustomTypography
                variant="body2"
                sx={{ color: theme?.palette?.customColors?.white }}
              >
                Loading orders...
              </CustomTypography> */}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100px",
                color: theme?.palette?.customColors?.greyTextColor,
              }}
            >
              <CustomTypography variant="body2">
                {search ? "No orders match your search" : "No orders available"}
              </CustomTypography>
            </Box>
          )}
        </Box>

        <AppTablePagenation
          fontSize="12px"
          fontColor="white"
          pageNo={filters.page_no || selectedFilters.page_no || 1}
          limit={projectManagementStore.limit}
          totalCount={projectManagementStore.total_count}
          onPageChange={(event, page) => {
            setAllowDefaultSelection(false);

            const updatedFilters = {
              ...filters,
              page_no: page,
            };
            setFilters(updatedFilters);
            updateSelectedFilters(updatedFilters);
            fetchProjectList("", updatedFilters);
          }}
          handleRowsChange={(value) => {
            setAllowDefaultSelection(false);

            const updatedFilters = {
              ...filters,
              limit: value,
              page_no: 1,
            };
            setFilters(updatedFilters);
            updateSelectedFilters(updatedFilters);
            fetchProjectList("", updatedFilters);
          }}
          showRowsPerPageOptions={false}
          showLabelRowsPerPage={false}
          arrowButtonColor="white"
        />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
          overflowX: "auto",
          width: "100%",
          scrollbarWidth: "none",
        }}
      >
        {/* header */}
        <Card
          sx={{
            p: 2,
            minHeight: "70px",
            position: "sticky",
            top: 0,
            zIndex: 1000,
            overflowX: "auto",
            whiteSpace: "nowrap",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              paddingLeft: 2,
              paddingRight: 2,
              justifyContent: "space-between",
              minWidth: "fit-content",
            }}
          >
            <Box sx={{ flexShrink: 0 }}>
              <CustomTypography
                variant="heading4"
                style={{
                  paddingLeft: useMediaQuery("(max-width:600px)") ? 10 : 0,
                }}
              >
                Ops-Sync
              </CustomTypography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                flexShrink: 0,
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: theme?.palette?.customColors?.lightGreyColor,
                  borderRadius: 50,
                  px: 2,
                  py: 0.5,
                  width: "35vw",
                  minWidth: "200px",
                  flexShrink: 0,
                }}
              >
                <InputBase
                  placeholder="Search Project"
                  value={search}
                  onChange={handleSearchChange}
                  onKeyDown={handleSearchKeyDown}
                  fullWidth
                  sx={{ ml: 1, fontSize: "0.9rem" }}
                />
                <SearchIcon
                  sx={{
                    color: theme?.palette?.customColors?.greyTextColor,
                    fontSize: 20,
                  }}
                />
              </Paper>
              <Box
                sx={{
                  position: "relative",
                  display: "inline-block",
                  flexShrink: 0,
                }}
              >
                <AppButton
                  variant="grayscale"
                  label="Filters"
                  startIcon={<FilterAltOutlinedIcon />}
                  customStyles={{
                    borderRadius: "20px",
                    textTransform: "none",
                    px: 2,
                    height: 36,
                  }}
                  onClick={() => {
                    handleFilterToggle();
                  }}
                />

                {filterCount > 0 && (
                  <Badge
                    color="primary"
                    badgeContent={filterCount}
                    sx={{
                      position: "absolute",
                      top: 5,
                      right: 5,
                      transform: "translate(50%, -50%)",
                    }}
                  />
                )}
              </Box>
              <AppButton
                label="Exit ops-sync"
                endIcon={<LogoutIcon />}
                customStyles={{
                  borderRadius: "20px",
                  height: 36,
                  minWidth: 150,
                  backgroundColor: theme?.palette?.customColors?.blackBorder,
                  color: theme?.palette?.customColors?.white,
                  "&:hover": {
                    backgroundColor:
                      theme?.palette?.customColors?.greyDarkborder,
                  },
                }}
                variant="grayscaleBlock"
                onClick={() =>
                  navigate(
                    "/project-management/listing?page_no=1&limit=30&sort_by=created_date&sort_type=DESC&project_type=1%3AActive",
                  )
                }
              />
            </Box>
          </Box>
        </Card>

        {projectManagementStore?.projectManagementList && (
          <Box
            sx={{
              paddingTop: "15px",
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              borderRadius: 2,
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            {selectedFiltersData.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  borderRadius: 2,
                }}
              >
                {selectedFiltersData.map((filter, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor:
                        theme?.palette?.mode === "dark"
                          ? theme?.palette?.background?.paper
                          : theme?.palette?.customColors?.lightGreyColor,
                      borderRadius: 5,
                      border: `1px solid ${theme?.palette?.customColors?.greyTextColor}`,
                      height: "30px",
                      paddingRight: "5px",
                    }}
                  >
                    <CustomTypography
                      variant="heading8"
                      color={theme?.palette?.customColors?.blackBorder}
                      style={{ paddingLeft: "10px", paddingRight: "5px" }}
                    >
                      {filter.value}
                    </CustomTypography>
                    <Button
                      onClick={() => handleRemoveFilter(index)}
                      sx={{
                        width: "14px",
                        height: "14px",
                        minWidth: "14px",
                        minHeight: "14px",
                        fontSize: "15px",
                        padding: "0px",
                        border: `1px solid ${theme?.palette?.customColors?.greyTextColor}`,
                        borderRadius: "50%",
                        backgroundColor: theme?.palette?.customColors?.white,
                        cursor: "pointer",
                        overflow: "hidden",
                        "&:hover": {
                          backgroundColor:
                            theme?.palette?.customColors?.lightGreyColor,
                        },
                      }}
                    >
                      ×
                    </Button>
                  </Box>
                ))}
                <Box>
                  <AppButton
                    label="Clear All"
                    onClick={() => {
                      handleClearFilters();
                    }}
                    customStyles={{
                      backgroundColor: "transparent",
                      padding: 1,
                      margin: 0,
                      minHeight: 20,
                      maxHeight: 20,
                      fontSize: "0.9rem",
                      color: theme?.palette?.customColors?.pinkDark,
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: theme?.palette?.purple?.main,
                        boxShadow: "none",
                      },
                    }}
                  />
                </Box>
              </Box>
            )}
          </Box>
        )}

        {/* order details */}
        <Card
          sx={{
            flex: 1,
            overflowX: "auto",
            scrollbarWidth: "none",
            margin: 2,
            padding: "15px 24px",
            minHeight: "220px",
            maxHeight: "220px",
            position: "relative",
          }}
        >
          {projectManagementStore?.refreshStates.basic && selectedOrderId ? (
            <Box
              sx={{
                display: "flex",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <CircularProgress size={40} />
              {/* <CustomTypography
                variant="body2"
                fontWeight={700}
                color={theme?.palette?.customColors?.greyTextColor}
              >
                Loading order details...
              </CustomTypography> */}
            </Box>
          ) : !selectedOrderId || !projectManagementStore.projectDetails ? (
            <Box
              sx={{
                display: "flex",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomTypography
                variant="body2"
                fontWeight={700}
                color={theme?.palette?.customColors?.greyTextColor}
              >
                ORDER DETAILS ARE NOT AVAILABLE!
              </CustomTypography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  paddingBottom: "10px",
                  gap: 5,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    // minWidth: "800px",
                    alignItems: "center",
                  }}
                >
                  <CustomTypography
                    variant="heading4"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                  >
                    #{projectManagementStore.projectDetails?.order_id}{" "}
                    {projectManagementStore.projectDetails?.customer_name}{" "}
                  </CustomTypography>
                  {projectManagementStore.projectDetails?.order_id && (
                    <IconButton
                      onClick={() => {
                        window.open(
                          `${window.location.origin}/projects/${projectManagementStore.projectDetails!.order_id}`,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }}
                      sx={{
                        color: theme.palette.primary.main,
                        backgroundColor: theme.palette.primary.main + "10",
                        width: 32,
                        height: 32,
                        "&:hover": {
                          backgroundColor: theme.palette.primary.main + "20",
                          transform: "scale(1.1)",
                        },
                        transition: "all 0.2s ease",
                      }}
                      size="small"
                      title="View Project"
                    >
                      <OpenInNewIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  )}

                  {projectManagementStore.projectDetails
                    ?.payment_status_label && (
                      <Chip
                        label={
                          projectManagementStore.projectDetails
                            ?.payment_status_label
                        }
                        sx={{
                          backgroundColor: theme?.palette?.mintGreen?.main,
                          paddingX: "10px",
                          height: "25px",
                          borderRadius: "4px",
                          fontWeight: 700,
                          ".MuiChip-label": {
                            padding: 0,
                            fontSize: "0.875rem",
                            fontWeight: 700,
                          },
                        }}
                      />
                    )}
                  {projectManagementStore.projectDetails?.order_type_label && (
                    <Chip
                      label={
                        projectManagementStore.projectDetails?.order_type_label
                      }
                      sx={{
                        backgroundColor: theme?.palette?.blushPink?.main,
                        paddingX: "10px",
                        height: "25px",
                        borderRadius: "4px",
                        fontWeight: 700,
                        ".MuiChip-label": {
                          padding: 0,
                          fontSize: "0.875rem",
                          fontWeight: 700,
                        },
                      }}
                    />
                  )}
                  {projectManagementStore.projectDetails?.archived &&
                    projectManagementStore.projectDetails?.archived_adminname ? (
                    <Box sx={{ whiteSpace: "nowrap" }}>
                      <CustomTypography
                        variant="heading7"
                        style={{
                          color: theme?.palette?.customColors?.greyTextColor,
                          fontWeight: 600,
                          paddingLeft: "10px",
                        }}
                      >
                        {" "}
                        Archived By{" "}
                        <span
                          style={{
                            fontWeight: 700,
                            color: theme?.palette?.customColors?.blackBorder,
                          }}
                        >
                          {projectManagementStore.projectDetails
                            ?.archived_adminname || "No Name"}
                        </span>{" "}
                        {" on "}
                        <span
                          style={{
                            fontWeight: 700,
                            color: theme?.palette?.customColors?.blackBorder,
                          }}
                        >
                          {dayjs(
                            projectManagementStore.projectDetails
                              ?.archived_date,
                          ).format("DD MMM, YYYY HH:mm")}
                        </span>
                      </CustomTypography>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    minWidth: "fit-content",
                    flexShrink: 0,
                    paddingRight: "10px",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      handleRefresh("basic");
                    }}
                    disabled={projectManagementStore?.refreshStates.basic}
                    sx={{ padding: 0 }}
                  >
                    {projectManagementStore?.refreshStates.basic ? (
                      <CircularProgress size={20} />
                    ) : (
                      <RefreshIcon
                        sx={{ color: theme?.palette?.customColors?.darkBlue }}
                      />
                    )}
                  </IconButton>

                  <IconButton onClick={handleClickOpen} sx={{ padding: 0 }}>
                    <Box
                      component="img"
                      src={chatGif}
                      alt="Chat"
                      sx={{ width: 35, height: 35 }}
                    />
                  </IconButton>
                  <AppButtonDropdown
                    label={
                      <CustomTypography
                        variant="heading7"
                        sx={{
                          fontWeight: 700,
                          color: theme?.palette?.customColors?.white,
                        }}
                      >
                        Actions
                      </CustomTypography>
                    }
                    options={
                      orderListingTab === "active"
                        ? [
                          {
                            label: "Create Task",
                            icon: <AddBoxOutlinedIcon fontSize="small" />,
                          },
                          {
                            label: "Feedback",
                            icon: <RateReviewOutlinedIcon fontSize="small" />,
                          },
                          {
                            label: "Archive Order",
                            icon: <ArchiveOutlinedIcon fontSize="small" />,
                          },
                        ]
                        : [
                          {
                            label: "Feedback",
                            icon: <RateReviewOutlinedIcon fontSize="small" />,
                          },
                          {
                            label: "Unarchive Order",
                            icon: <UnarchiveIcon fontSize="small" />,
                          },
                        ]
                    }
                    onSelect={(option) => {
                      if (option === "Create Task") {
                        setOpenCreateTaskModal(true);
                      } else if (option === "Archive Order") {
                        handleArchiveOrderClick();
                      } else if (option === "Feedback") {
                        setFeedbackOnlyMode(true);
                        handleOpenArchivePopup();
                      } else if (option === "Unarchive Order") {
                        setUnarchiveConfirmationPopup(true);
                      }
                    }}
                  />
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "space-between",
                }}
              >
                <Box display="flex" flexDirection="column">
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ padding: "0.625rem 0rem 0.75rem 0rem" }}
                  >
                    <img src={GlobeIcon} alt="shipment" />
                    <CustomTypography
                      variant="heading7"
                      style={{ paddingRight: "27px" }}
                    >
                      Shipment
                    </CustomTypography>
                    {projectManagementStore.projectDetails
                      ?.shipping_type_label && (
                        <Chip
                          label={
                            projectManagementStore.projectDetails
                              ?.shipping_type_label
                          }
                          sx={{
                            backgroundColor: theme?.palette?.goldenYellow?.main,
                            paddingX: "10px",
                            paddingY: "2px",
                            height: "25px",
                            borderRadius: "4px",
                            fontWeight: 700,
                            ".MuiChip-label": {
                              padding: 0,
                              fontSize: "0.875rem",
                              fontWeight: 700,
                            },
                          }}
                        />
                      )}
                    {projectManagementStore.projectDetails
                      ?.shipment_mode_label && (
                        <Chip
                          label={
                            projectManagementStore.projectDetails
                              ?.shipment_mode_label
                          }
                          sx={{
                            backgroundColor: theme?.palette?.blushPink?.main,
                            paddingX: "10px",
                            paddingY: "2px",
                            height: "25px",
                            borderRadius: "4px",
                            fontWeight: 700,
                            ".MuiChip-label": {
                              padding: 0,
                              fontSize: "0.875rem",
                              fontWeight: 700,
                            },
                          }}
                        />
                      )}
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ padding: "0.75rem 0rem 0.75rem 0rem" }}
                  >
                    <img src={DispatchIcon} alt="dispatch" />
                    <CustomTypography
                      variant="heading7"
                      style={{ paddingRight: "35px" }}
                    >
                      Dispatch
                    </CustomTypography>
                    {projectManagementStore.projectDetails?.dispatch_date ? (
                      <Chip
                        label={dayjs(
                          projectManagementStore.projectDetails?.dispatch_date,
                        ).format("DD MMM, YYYY")}
                        sx={{
                          backgroundColor: theme?.palette?.brown?.main,
                          paddingX: "10px",
                          paddingY: "2px",
                          height: "25px",
                          borderRadius: "4px",
                          fontWeight: 700,
                          ".MuiChip-label": {
                            padding: 0,
                            fontSize: "0.875rem",
                            fontWeight: 700,
                          },
                        }}
                      />
                    ) : (
                      "-"
                    )}
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ padding: "0.75rem 0rem 0.3125rem 0rem" }}
                  >
                    <img src={POCIcon} alt="sales-poc" />

                    <CustomTypography
                      variant="heading7"
                      style={{
                        paddingRight: "29px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Sales POC
                    </CustomTypography>

                    <CustomTypography
                      variant="body1"
                      color="text.secondary"
                      fontWeight={600}
                      style={{
                        whiteSpace: "nowrap",
                        color: theme?.palette?.customColors?.greyTextColor,
                      }}
                    >
                      {projectManagementStore.projectDetails?.sales_admin_name}
                    </CustomTypography>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="column">
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ padding: "0.625rem 0rem 0.75rem 0rem" }}
                  >
                    <img src={flagIcon} alt="Category" />
                    <CustomTypography
                      variant="heading7"
                      style={{ paddingRight: "30px" }}
                    >
                      Category
                    </CustomTypography>
                    {(() => {
                      const selectedOrder =
                        projectManagementStore.projectManagementList?.find(
                          (order) => order.order_id === selectedOrderId,
                        );
                      const orderColor = getPriorityBandColor(
                        selectedOrder?.days_to_dispatch || 0,
                      );
                      const orderCategory = getPriorityCategory(
                        selectedOrder?.days_to_dispatch || 0,
                      );

                      return (
                        <Box display="flex" alignItems="center" gap={1}>
                          <FlagIcon
                            style={{
                              color: orderColor,
                            }}
                          />
                          <CustomTypography
                            variant="heading7"
                            color={theme?.palette?.customColors?.greyTextColor}
                            fontWeight={600}
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {orderCategory?.name || "No Category"}
                          </CustomTypography>
                        </Box>
                      );
                    })()}
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ padding: "0.75rem 0rem 0.75rem 0rem" }}
                  >
                    <img src={DispatchIcon} alt="dispatch" />
                    <CustomTypography
                      variant="heading7"
                      style={{ paddingRight: "35px" }}
                    >
                      Delivery
                    </CustomTypography>
                    {projectManagementStore.projectDetails?.delivery_date ? (
                      <Chip
                        label={dayjs(
                          projectManagementStore.projectDetails?.delivery_date,
                        ).format("DD MMM, YYYY")}
                        sx={{
                          backgroundColor:
                            theme?.palette?.customColors?.lightBlue,
                          paddingX: "10px",
                          paddingY: "2px",
                          height: "25px",
                          borderRadius: "4px",
                          fontWeight: 700,
                          ".MuiChip-label": {
                            padding: 0,
                            fontSize: "0.875rem",
                            fontWeight: 700,
                          },
                        }}
                      />
                    ) : (
                      "-"
                    )}
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ padding: "0.75rem 0rem 0.3125rem 0rem" }}
                  >
                    <img src={POCIcon} alt="sales-poc" />
                    <CustomTypography
                      variant="heading7"
                      style={{ paddingRight: "12px", whiteSpace: "nowrap" }}
                    >
                      Project Mgr
                    </CustomTypography>
                    <CustomTypography
                      variant="body1"
                      color="text.secondary"
                      fontWeight={600}
                      style={{
                        whiteSpace: "nowrap",
                        color: theme?.palette?.customColors?.greyTextColor,
                      }}
                    >
                      {projectManagementStore.projectDetails?.pm_admin_name}
                    </CustomTypography>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  gap={1.5}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: 1.75,
                    pr: "20px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    marginTop="7px"
                    sx={{ flexWrap: "nowrap" }}
                  >
                    <img src={TATIcon} alt="tat" />
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <CustomTypography
                        variant="heading8"
                        style={{
                          color: theme?.palette?.customColors?.greyTextColor,
                          paddingBottom: "5px",
                        }}
                      >
                        Live vs Exp TAT
                      </CustomTypography>
                      <CustomTypography
                        variant="heading7"
                        style={{
                          display: "inline-flex",
                          gap: 1.5,
                          fontWeight: 600,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            color: theme?.palette?.customColors?.purpleMain,
                          }}
                        >
                          {projectManagementStore.projectDetails?.tat} {""}D
                        </Box>
                        <Box component="span">
                          {"  / "}
                          {
                            projectManagementStore.projectDetails?.expected_tat
                          }{" "}
                          D
                        </Box>
                      </CustomTypography>
                    </Box>
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1.5}
                    sx={{ flexWrap: "nowrap" }}
                  >
                    <img src={CalendarIcon} alt="created-date" />
                    <Box sx={{ whiteSpace: "nowrap" }}>
                      <CustomTypography
                        variant="heading8"
                        style={{
                          color: theme?.palette?.customColors?.greyTextColor,
                          paddingBottom: "5px",
                        }}
                      >
                        Created Date
                      </CustomTypography>
                      {projectManagementStore.projectDetails?.created_date ? (
                        <CustomTypography
                          variant="heading7"
                          style={{ fontWeight: 600 }}
                        >
                          {dayjs(
                            projectManagementStore.projectDetails?.created_date,
                          ).format("DD MMM, YYYY")}{" "}
                          {dayjs(
                            projectManagementStore.projectDetails?.created_date,
                          ).format("HH:mm")}
                        </CustomTypography>
                      ) : (
                        "-"
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Card>

        <Box sx={{ width: "100%", display: "block" }}>
          <Card
            sx={{
              overflowX: "auto",
              overflowY: "visible",
              scrollbarWidth: "none",
              marginLeft: 2,
              marginRight: 2,
              marginBottom: 3,
              padding: "5px 24px",
              height: "auto",
              paddingBottom: 3,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              gap={3}
              alignItems="center"
              sx={{
                flexWrap: "nowrap",
                overflowX: "auto",
                scrollbarWidth: "none",
                minWidth: 0,
              }}
            >
              <Tabs
                value={ProductSectionTab}
                onChange={(e, newValue) =>
                  setTabStates((prev) => ({
                    ...prev,
                    ProductSectionTab: newValue,
                  }))
                }
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  // mb: 2,
                  flex: 1,
                  minWidth: 0,
                  ".MuiTab-root": {
                    textTransform: "none",
                    fontWeight: 600,

                    fontSize: "0.875rem",
                    color: theme?.palette?.customColors?.greyTextColor,
                    minWidth: "auto",
                    padding: "12px 16px",
                  },
                  ".Mui-selected": {
                    color: theme?.palette?.purple?.main,
                  },
                  ".MuiTabs-indicator": {
                    backgroundColor: theme?.palette?.purple?.main,
                  },
                  ".MuiTabs-scrollButtons": {
                    color: theme?.palette?.customColors?.greyTextColor,
                  },
                  [theme.breakpoints.down("sm")]: {
                    ".MuiTab-root": {
                      fontSize: "0.875rem",
                      padding: "12px 12px",
                      minWidth: 90,
                    },
                  },
                }}
              >
                <Tab label="Information" value="information" />
                <Tab label="Task Tracker" value="task-tracker" />
                <Tab label="Experience" value="ratings" />
              </Tabs>
              <IconButton
                onClick={() =>
                  ProductSectionTab === "information"
                    ? handleRefresh("information")
                    : ProductSectionTab === "task-tracker"
                      ? handleRefresh("taskTracker")
                      : handleRefresh("ratings")
                }
                disabled={
                  ProductSectionTab === "information"
                    ? projectManagementStore?.refreshStates.information
                    : TaskTrackerStore?.refreshStates.taskTracker ||
                    projectManagementStore?.refreshStates.ratings
                }
                sx={{
                  padding: 0,
                  flexShrink: 0, // Prevent the button from shrinking
                  ml: 1, // Add some margin for spacing
                  [theme.breakpoints.down("sm")]: {
                    padding: "4px",
                    "& svg": {
                      fontSize: "1.2rem",
                    },
                  },
                }}
              >
                {(ProductSectionTab === "information" &&
                  projectManagementStore?.refreshStates.information) ||
                  TaskTrackerStore?.refreshStates.taskTracker ||
                  projectManagementStore?.refreshStates.ratings ? (
                  <CircularProgress size={20} />
                ) : (
                  <RefreshIcon
                    sx={{ color: theme?.palette?.customColors?.darkBlue }}
                  />
                )}
              </IconButton>
            </Box>

            {ProductSectionTab === "information" && (
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                {projectManagementStore?.refreshStates.information &&
                  selectedOrderId ? (
                  <Box
                    sx={{
                      display: "flex",
                      height: "calc(100vh - 500px)",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: 2,
                      mt: 2,
                    }}
                  >
                    <CircularProgress size={40} />
                    {/* <CustomTypography variant="heading6">
                      Loading information...
                    </CustomTypography> */}
                  </Box>
                ) : (
                  <Box sx={{ width: "100%", mt: 2 }}>
                    <OpsSyncProductTable
                      data={
                        projectManagementStore?.opsSyncProjectProductProgress ||
                        []
                      }
                      taskTypes={
                        projectManagementStore.opsSyncProjectTaskTypes || []
                      }
                    />
                  </Box>
                )}
              </Box>
            )}
            {ProductSectionTab === "task-tracker" && (
              <Box>
                {TaskTrackerStore?.refreshStates.taskTracker &&
                  TaskTrackerStore?.tasks?.length > 0 &&
                  TaskTrackerStore?.tasks[0]?.order_id === selectedOrderId ? (
                  <Box
                    sx={{
                      display: "flex",
                      height: "calc(100vh - 500px)",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: 2,
                      mt: 2,
                    }}
                  >
                    <CircularProgress size={40} />
                  </Box>
                ) : (
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "15px",
                        gap: 2,
                        overflowY: "visible",
                        scrollbarWidth: "none",
                        pt: 2,
                      }}
                    >
                      <Box>
                        <Paper
                          elevation={0}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor:
                              theme?.palette?.customColors?.lightGreyColor,
                            borderRadius: 50,
                            px: 2,
                            py: 0.5,
                            minWidth: "200px",
                            flexShrink: 0,
                          }}
                        >
                          <InputBase
                            placeholder="Search Task"
                            value={taskSearchTerm}
                            onChange={handleTaskSearchChange}
                            onKeyDown={handleTaskSearchKeyDown}
                            fullWidth
                            sx={{ ml: 1, fontSize: "0.9rem" }}
                          />
                          <SearchIcon
                            sx={{
                              color:
                                theme?.palette?.customColors?.greyTextColor,
                              fontSize: 20,
                            }}
                          />
                        </Paper>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1.5,
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: 1.5,
                            alignItems: "center",
                          }}
                        >
                          <CustomTypography variant="body1">
                            Owner:
                          </CustomTypography>

                          <AppSearchDropDown2
                            title="Select Owner"
                            isMultiSelect={true}
                            fontSize="13px"
                            minWidth="150px"
                            borderColor={theme.palette.customColors.purple}
                            list={
                              TaskTrackerStore?.admins?.map((admin) => ({
                                id: admin.id.toString(),
                                value: admin.name,
                              })) || []
                            }
                            local={false}
                            handleSearch={(name?: string) =>
                              handleOwnerSearch(name || "")
                            }
                            handleSelect={(selectedAdmin) => {
                              if (selectedAdmin.length > 0) {
                                const ownerIds = selectedAdmin.map((admin) =>
                                  Number(admin.id),
                                );
                                const ownerNames = selectedAdmin.map(
                                  (admin) => admin.value,
                                );
                                setTaskTrackerParams((prev) => ({
                                  ...prev,
                                  selectedOwnerName: ownerNames,
                                  owner_id: ownerIds,
                                  page_no: 1,
                                }));
                              } else {
                                setTaskTrackerParams((prev) => ({
                                  ...prev,
                                  selectedOwnerName: [],
                                  owner_id: [],
                                  page_no: 1,
                                }));
                              }
                            }}
                            value={taskTrackerParams.owner_id.map(
                              (id, index) => {
                                return {
                                  id: id.toString(),
                                  value:
                                    taskTrackerParams.selectedOwnerName[
                                    index
                                    ] || `Admin ${id}`,
                                };
                              },
                            )}
                          />
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            gap: 1.5,
                            alignItems: "center",
                          }}
                        >
                          <CustomTypography variant="body1">
                            Assignee:
                          </CustomTypography>

                          <AppSearchDropDown2
                            title="Select Assignee"
                            isMultiSelect={true}
                            fontSize="13px"
                            minWidth="150px"
                            borderColor={theme.palette.customColors.purple}
                            list={
                              TaskTrackerStore?.admins?.map((admin) => ({
                                id: admin.id.toString(),
                                value: admin.name,
                              })) || []
                            }
                            local={false}
                            handleSearch={(name?: string) =>
                              handleAssigneeSearch(name || "")
                            }
                            handleSelect={(selectedAdmin) => {
                              if (selectedAdmin.length > 0) {
                                const assigneeIds = selectedAdmin.map((admin) =>
                                  Number(admin.id),
                                );
                                const assigneeNames = selectedAdmin.map(
                                  (admin) => admin.value,
                                );
                                setTaskTrackerParams((prev) => ({
                                  ...prev,
                                  selectedAssigneeName: assigneeNames,
                                  assignee_id: assigneeIds,
                                  page_no: 1,
                                }));
                              } else {
                                setTaskTrackerParams((prev) => ({
                                  ...prev,
                                  selectedAssigneeName: [],
                                  assignee_id: [],
                                  page_no: 1,
                                }));
                              }
                            }}
                            value={taskTrackerParams.assignee_id.map(
                              (id, index) => {
                                return {
                                  id: id.toString(),
                                  value:
                                    taskTrackerParams.selectedAssigneeName[
                                    index
                                    ] || `Admin ${id}`,
                                };
                              },
                            )}
                          />
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            gap: 1.5,
                            alignItems: "center",
                          }}
                        >
                          <CustomTypography variant="body1">
                            Status:
                          </CustomTypography>
                          <Box sx={{ minWidth: "150px" }}>
                            <AppDropDown
                              title=""
                              isMultiSelect={false}
                              fontSize="13px"
                              borderColor={theme.palette.customColors.purple}
                              list={[
                                {
                                  id: "0",
                                  value: "All",
                                },
                                ...status_list,
                              ]}
                              value={
                                taskTrackerParams.status
                                  ? String(taskTrackerParams.status)
                                  : "0"
                              }
                              onSingleSelectionChange={
                                handleTaskStatusFilterChange
                              }
                              listPadding={"2px"}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <OpsSyncTaskTrackerTable
                        data={TaskTrackerStore?.tasks || []}
                        sortBy={taskTrackerParams?.sortBy}
                        sortType={taskTrackerParams?.sortType}
                        onSortChange={(column) => {
                          setTaskTrackerParams((prev) => ({
                            ...prev,
                            sortBy: column,
                            sortType:
                              prev?.sortBy === column &&
                                prev?.sortType === SortType.ASC
                                ? SortType.DESC
                                : SortType.ASC,
                          }));
                        }}
                        total_count={TaskTrackerStore?.total_count || 0}
                        limit={taskTrackerParams?.limit || 30}
                        page_no={taskTrackerParams?.page_no || 1}
                        onPageChange={(event, page) => {
                          setTaskTrackerParams((prev) => ({
                            ...prev,
                            page_no: page,
                          }));
                        }}
                        onRowsChange={(rowsPerPage) => {
                          setTaskTrackerParams((prev) => ({
                            ...prev,
                            limit: rowsPerPage,
                            page_no: 1,
                          }));
                        }}
                        onTaskSuccess={(taskData: Task) => {
                          setSuccessPopup({
                            open: true,
                            message: taskData.id
                              ? "Task updated successfully!"
                              : "Task created successfully!",
                          });
                          if (selectedOrderId) {
                            TaskTrackerStore?.refreshTaskTracker(
                              selectedOrderId,
                              {
                                ...taskTrackerParams,
                                search_text: taskSearchTerm,
                              },
                              TaskTrackerStore,
                            );
                          }
                        }}
                        onTaskError={(error) => {
                          showError(
                            "Error occurred",
                            error?.response?.data?.message ||
                            "Something went wrong! Please try again later.",
                          );
                        }}
                        onStatusUpdate={handleTaskStatusUpdate}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            )}
            {ProductSectionTab === "ratings" && (
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
              >
                {projectManagementStore?.refreshStates.ratings ? (
                  <Box
                    sx={{
                      display: "flex",
                      height: "calc(100vh - 500px)",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <CircularProgress size={40} />
                    {/* <CustomTypography variant="heading6">
                      Loading Experience...
                    </CustomTypography> */}
                  </Box>
                ) : (
                  <Box sx={{ width: "100%" }}>
                    <OpsSyncRatingExperience
                      projectRatings={projectManagementStore.projectRatings}
                      departmentList={projectManagementStore.departmentList}
                    // maxHeight={window.innerHeight - 400}
                    />
                  </Box>
                )}
              </Box>
            )}
          </Card>
        </Box>
        {openFilter && (
          <FilterSidebar
            isOpen={openFilter}
            items={filterMenu}
            onApply={handleApplyFilters}
            handleClear={handleClearFilters}
            toggleFilter={handleFilterToggle}
            disablePastDates={false}
            disableFutureDates={false}
          />
        )}
        <OpsSyncInstructionPopup
          open={popupStates.instruction}
          onClose={() =>
            setPopupStates((prev) => ({ ...prev, instruction: false }))
          }
          additionalData={
            projectManagementStore.projectDetails?.order_additional_info || ""
          }
        />
        <ArchiveOrderPopup
          departmentList={
            projectManagementStore?.departmentList?.map((dept) => dept.name) ||
            []
          }
          open={popupStates.Feedback}
          onClose={handleCloseArchivePopup}
          selectedOrderId={selectedOrderId}
          orderCustomerName={
            projectManagementStore.projectDetails?.customer_name
          }
          onSaveFeedback={handleArchiveWithFeedback}
          feedbackOnly={feedbackOnlyMode}
          existingRatings={
            (projectManagementStore?.projectRatings || []).filter(
              (r) => r.project_id === selectedOrderId
            ) as import("../../../../models/OpsSync/OpsSyncFeedbackForm").ExistingRatingForPrefill[]
          }
          departmentIdToName={Object.fromEntries(
            (projectManagementStore?.departmentList || []).map((d) => [
              d.id,
              d.name,
            ]),
          )}
          inlineSuccessMessage={feedbackInlineSuccessMessage ?? undefined}
          onDismissInlineSuccess={() => setFeedbackInlineSuccessMessage(null)}
        />

        <Modal
          open={openCreateTaskModal}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setOpenCreateTaskModal(false);
            }
          }}
          aria-labelledby="create-task-modal-title"
          aria-describedby="create-task-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              maxHeight: "90vh",
              overflow: "auto",
              bgcolor: "background.paper",
              p: 0,
              borderRadius: "4px",
              boxShadow: 24,
              width: "60vw",
              minWidth: "400px",
              maxWidth: "800px",
            }}
          >
            <IconButton
              onClick={() => setOpenCreateTaskModal(false)}
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 10,
              }}
            >
              <CloseIcon />
            </IconButton>

            <AddEditTask
              isModal={true}
              onClose={() => setOpenCreateTaskModal(false)}
              orderId={selectedOrderId ?? 0}
              isNavigationNeeded={false}
              onSuccess={(taskData: Task) => {
                setOpenCreateTaskModal(false);
                setSuccessPopup({
                  open: true,
                  message: taskData.id
                    ? "Task updated successfully!"
                    : "Task created successfully!",
                });
                setTabStates((prev) => ({
                  ...prev,
                  ProductSectionTab: "task-tracker",
                }));
                if (selectedOrderId) {
                  TaskTrackerStore?.refreshTaskTracker(
                    selectedOrderId,
                    {
                      ...taskTrackerParams,
                      search_text: taskSearchTerm,
                    },
                    TaskTrackerStore,
                  );
                }
              }}
            />
          </Box>
        </Modal>
        <SuccessPopup
          open={successPopup.open}
          successMessage={successPopup.message}
          onClose={() => setSuccessPopup({ open: false, message: "" })}
        />

        <Dialog
          maxWidth="sm"
          fullWidth
          open={archiveChoicePopup}
          onClose={() => setArchiveChoicePopup(false)}
          slotProps={{
            paper: {
              sx: {
                borderRadius: "16px",
                overflow: "hidden",
                boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
                paddingBottom: "20px",
              },
            },
          }}
        >
          <Box
            sx={{
              background: `linear-gradient(135deg, ${theme?.palette?.customColors?.purple}18 0%, ${theme?.palette?.customColors?.purple}06 100%)`,
              borderBottom: `1px solid ${theme?.palette?.customColors?.purple}22`,
              px: 2.5,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <ArchiveOutlinedIcon sx={{ color: theme?.palette?.customColors?.purple, fontSize: 18 }} />
              <CustomTypography variant="heading6" fontWeight={700}>
                Archive Order
              </CustomTypography>
            </Box>
            <IconButton size="small" onClick={() => setArchiveChoicePopup(false)}>
              <CloseIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
          <DialogContent sx={{ px: 2.5, py: 2.5 }}>
            <CustomTypography variant="heading8" color={theme?.palette?.customColors?.greyTextColor}>
              How would you like to archive this order?
            </CustomTypography>
            <Box display="flex" flexDirection="column" gap={1.5} mt={2}>
              <Button
                fullWidth
                onClick={() => {
                  setArchiveChoicePopup(false);
                  setFeedbackOnlyMode(false);
                  handleOpenArchivePopup();
                }}
                sx={{
                  textTransform: "none",
                  borderRadius: "10px",
                  py: 1.5,
                  px: 2,
                  justifyContent: "flex-start",
                  gap: 1.5,
                  border: `1px solid ${theme?.palette?.customColors?.purple}40`,
                  bgcolor: `${theme?.palette?.customColors?.purple}08`,
                  color: theme?.palette?.customColors?.purple,
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  "&:hover": { bgcolor: `${theme?.palette?.customColors?.purple}14` },
                }}
              >
                <FeedbackOutlinedIcon sx={{ fontSize: 20 }} />
                <Box textAlign="left">
                  <Box fontWeight={700} fontSize="0.85rem">Archive with Feedback</Box>
                  <Box fontSize="0.72rem" sx={{ opacity: 0.75, fontWeight: 400 }}>Rate departments before archiving</Box>
                </Box>
              </Button>
              <Button
                fullWidth
                onClick={() => {
                  setArchiveChoicePopup(false);
                  setArchiveConfirmationPopup(true);
                }}
                sx={{
                  textTransform: "none",
                  borderRadius: "10px",
                  py: 1.5,
                  px: 2,
                  justifyContent: "flex-start",
                  gap: 1.5,
                  border: `1px solid rgba(0,0,0,0.10)`,
                  bgcolor: "rgba(0,0,0,0.02)",
                  color: theme?.palette?.text?.primary,
                  fontWeight: 600,
                  fontSize: "0.85rem",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.06)" },
                }}
              >
                <DoNotDisturbOnOutlinedIcon sx={{ fontSize: 20, opacity: 0.6 }} />
                <Box textAlign="left">
                  <Box fontWeight={700} fontSize="0.85rem">Archive without Feedback</Box>
                  <Box fontSize="0.72rem" sx={{ opacity: 0.6, fontWeight: 400 }}>Skip feedback and archive directly</Box>
                </Box>
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <ConfirmationPopup
          open={archiveConfirmationPopup}
          id={selectedOrderId || 0}
          title="Confirm Archive Order"
          content={`Are you sure you want to archive order #${selectedOrderId}? Make sure raw inward and if applicable print inward of all the products are completed. All shipments must be properly created and updated.`}
          onConfirm={handleArchiveOrder}
          onCancel={() => setArchiveConfirmationPopup(false)}
        />
        <ConfirmationPopup
          open={unarchiveConfirmationPopup}
          id={selectedOrderId || 0}
          title="Confirm Unarchive Order"
          content={`Are you sure you want to unarchive order #${selectedOrderId}?`}
          onConfirm={handleUnarchiveOrder}
          onCancel={() => setUnarchiveConfirmationPopup(false)}
        />
      </Box>
    </Box>
  );
};

export default observer(OpsSync);
